module.exports = __webpack_public_path__ + "media/images/icons/settings-6919eac8b3b01b398b51569676fd4f33.svg";